import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-slough',
    templateUrl: './page-slough.component.html',
    styleUrls: ['./page-slough.component.css'],
    standalone: false
})
export class PageSloughComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  schools = [
    { name: 'Langley Grammar School', url: 'https://www.lgs.slough.sch.uk/' },
    { name: 'Herschel Grammar School', url: 'http://www.herschel.slough.sch.uk/'},
    { name: 'Upton Court Grammar School', url: 'http://www.uptoncourtgrammar.org.uk/'},
    { name: 'St Bernard’s Catholic Grammar School', url: 'http://www.st-bernards.slough.sch.uk/'},
  ]

}
